import { createSelector } from 'reselect';
import { keys, values, orderBy } from 'lodash';
import {
  cachedDispatchersByType,
  getCommonPageJobInfo,
  getDispatcherNameNumberJobIdPairs,
  getDispatcherType,
  regressionPageDispatchersByJobIds
} from '../reducers';

export const getDispatcherJobInfo = createSelector(
  (state) => getCommonPageJobInfo(state).jobName,
  (state) => getCommonPageJobInfo(state).jobNumber,
  (state) => getCommonPageJobInfo(state).numJobs,
  getDispatcherType,
  getDispatcherNameNumberJobIdPairs,
  regressionPageDispatchersByJobIds,
  (jobName, jobNumber, numJobs, type, jobIdByDispNameNumber, dispIdByJobId) => {
    if (!jobName && !jobNumber)
    {
      return {};
    }
    const jobNameNumber = jobName && jobNumber ?
      `${jobName}_${jobNumber}` :
      undefined;
    const jobId = jobIdByDispNameNumber[jobNameNumber];
    const selectedDispatcherId = jobId ? dispIdByJobId[jobId][0].id : '';

    return {
      title: jobNameNumber ? jobNameNumber : 'Params: None Selected',
      dispatcherId: selectedDispatcherId,
      jobId: jobId ? jobId : '',
      jobName: jobName ? jobName : '',
      jobNumber: jobNumber ? jobNumber : '',
      numJobs: numJobs ? numJobs : 25
    };
  }
);

export const dispatchersAndJobsByName = createSelector(
  (state) => cachedDispatchersByType(state, getDispatcherType(state)),
  (dispatchers) => dispatchers.reduce(
    (result, dispatcher) => {
      if (!dispatcher.job)
      {
        return { 'dispatchers': {}, 'jobs': {}};
      }
      result['dispatchers'][dispatcher.job.name] =
      [...(result['dispatchers'][dispatcher.job.name] || []), dispatcher];
      result['jobs'][dispatcher.job.name] =
      [...(result['jobs'][dispatcher.job.name] || []), dispatcher.job];
      return result;
    }, { 'dispatchers': {}, 'jobs': {}}
  )
);

export const recentDispatchersAndJobsByName = createSelector(
  (state) => getCommonPageJobInfo(state).numJobs,
  dispatchersAndJobsByName,
  (numJobs, dispatchersAndJobsByName) => keys(dispatchersAndJobsByName['jobs']).reduce(
    (result, jobName) => {
      const dispatchers = dispatchersAndJobsByName['dispatchers'][jobName] || [];
      const jobs = dispatchersAndJobsByName['jobs'][jobName] || [];

      // show the latest dispatchers for selection
      result['dispatchers'][jobName] = orderBy(
        dispatchers, d => d.created_at, 'desc').slice(0, numJobs);
      result['jobs'][jobName] = orderBy(
        jobs, d => d.created_at, 'desc').slice(0, numJobs);
      return result;
    }, { 'dispatchers': {}, 'jobs': {}})
);

export const getDispatcherJobsByDispIds = createSelector(
  (state) => getCommonPageJobInfo(state).jobName,
  dispatchersAndJobsByName,
  (jobName, dispatchesAndJobs) => {
    const dispatchers = dispatchesAndJobs.dispatchers;
    if (!jobName)
    {
      return {};
    }
    const dispatcherJobsByDispIds = {};

    dispatchers[jobName] &&
     values(dispatchers[jobName]).forEach(dispatcher => {
       dispatcherJobsByDispIds[dispatcher.id] = dispatcher.job;
     });

    return dispatcherJobsByDispIds;
  }
);

export const getDispatcherIds = state =>
  keys(getDispatcherJobsByDispIds(state)).map(id => parseInt(id));

/**
 * @deprecated
 * Phase out and replace with one feeding from recentDispatchersAndJobsByName.
 * As is, this side steps the new input field exposed for `numJobs`
 */
export const getRecentDispatcherIds = state =>
  getDispatcherIds(state).sort((a, b) => b - a).slice(0, 10);


// WEBPACK FOOTER //
// src/selectors/dispatcher.js